module.exports = __webpack_public_path__ + "static/media/typescript.8656e839.png";